<template>
  <v-card outlined class="mt-5">
    <v-card-title class="d-flex">
      <h2>Facility Equipment</h2>
      <v-spacer></v-spacer>
      <add-equipment-modal />
    </v-card-title>
    <v-card-text>
      <v-data-table :items="equipment" :headers="headers" :search="search">
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search equipment..."
            prepend-icon="mdi-magnify"
            class="mx-4"
            single-line
            hide-details
          ></v-text-field>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip small outlined>
            {{ item.type === "tool" ? "Tool" : "Equipment" }}
          </v-chip>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-chip small :color="item.is_active ? 'green' : 'grey'" dark>
            {{ item.is_active ? "Active" : "Inactive" }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="primary" @click="openEdit(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            color="red"
            :disabled="!item.is_active"
            @click="retire(item)"
          >
            <v-icon small>mdi-archive</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <edit-equipment-modal
        :show.sync="editDialog"
        :equipment="selectedEquipment"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import AddEquipmentModal from "./addEquipmentModal.vue";
import EditEquipmentModal from "./editEquipmentModal.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { AddEquipmentModal, EditEquipmentModal },
  computed: {
    ...mapGetters({
      equipment: "facilities/equipment",
    }),
  },
  methods: {
    ...mapActions({
      get_equipment: "facilities/get_equipment",
      retire_equipment: "facilities/retire_equipment",
    }),
    openEdit(equipment) {
      this.selectedEquipment = Object.assign({ type: "equipment" }, equipment);
      this.editDialog = true;
    },
    async retire(equipment) {
      const ok = await this.$confirm(
        `Retire "${equipment.name}"? It will no longer appear on checklists.`
      );
      if (!ok) return;
      try {
        await this.retire_equipment(equipment.id);
        this.$alert({
          title: "Retired",
          message: `${equipment.name} has been retired.`,
          color: "success",
        });
      } catch (e) {
        console.error(e);
        this.$alert({
          title: "Error",
          message: "Failed to retire equipment.",
          color: "error",
        });
      }
    },
  },
  data() {
    return {
      search: "",
      editDialog: false,
      selectedEquipment: {},
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Type", value: "type" },
        { text: "Category", value: "category" },
        { text: "Designated Location", value: "designated_location" },
        { text: "Order", value: "sort_order" },
        { text: "Active", value: "is_active" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    if (this.equipment.length == 0) return this.get_equipment();
  },
};
</script>
